import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
 :root {
  --globe-red: #9B1417;
  --globe-blue: #005DC7;
  --globe-dkgray: #767676;
  --globe-offwhite: #F4F4F4;
  --globe-link: #005DC7;
  --offblack: #333;
  --offwhite: #efefef;
  --content-max-width: 1000px;

  --custom-green: #278763;
  --custom-light-green: #c0eddc;
  --block-font: 'Alfa Slab One', Impact, arial, sans-serif;
 }
`;

export default GlobalStyles;
